export default function MaterialChangeDialogController(
  $scope,

  ssDialogService,
) {
  const vm = this;
  vm.handleClose = _handleClose;
  vm.handleSubmit = _handleSubmit;
  vm.isMaterialChange = 'no';
  vm.explanation = null;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSubmit() {
    if ($scope.materialChangeForm.$valid) {
      if (vm.isMaterialChange === 'yes') {
        vm._isMaterialChange = true;
      } else {
        vm._isMaterialChange = false;
      }
      const explanation = { explanation: vm.explanation, isMaterialChange: vm._isMaterialChange };
      vm.callback(explanation);
      _closeDialog();
    }
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.materialChangeDialog);
  }
}

MaterialChangeDialogController.$inject = [
  '$scope',

  'ssDialogService',
];
